<div class="modal">
  <style type="text/css">
    .lst-kix_list_4-1>li {
      counter-increment: lst-ctn-kix_list_4-1
    }

    ol.lst-kix_list_7-0 {
      list-style-type: none
    }

    .lst-kix_list_2-1>li {
      counter-increment: lst-ctn-kix_list_2-1
    }

    .lst-kix_list_6-1>li {
      counter-increment: lst-ctn-kix_list_6-1
    }

    ol.lst-kix_list_3-1.start {
      counter-reset: lst-ctn-kix_list_3-1 0
    }

    ol.lst-kix_list_6-6.start {
      counter-reset: lst-ctn-kix_list_6-6 0
    }

    ol.lst-kix_list_7-4.start {
      counter-reset: lst-ctn-kix_list_7-4 0
    }

    .lst-kix_list_5-0>li {
      counter-increment: lst-ctn-kix_list_5-0
    }

    .lst-kix_list_7-0>li {
      counter-increment: lst-ctn-kix_list_7-0
    }

    ol.lst-kix_list_2-3.start {
      counter-reset: lst-ctn-kix_list_2-3 0
    }

    ol.lst-kix_list_7-5 {
      list-style-type: none
    }

    ol.lst-kix_list_7-6 {
      list-style-type: none
    }

    ol.lst-kix_list_7-7 {
      list-style-type: none
    }

    ol.lst-kix_list_7-8 {
      list-style-type: none
    }

    ol.lst-kix_list_7-1 {
      list-style-type: none
    }

    ol.lst-kix_list_1-5.start {
      counter-reset: lst-ctn-kix_list_1-5 0
    }

    ol.lst-kix_list_7-2 {
      list-style-type: none
    }

    ol.lst-kix_list_7-3 {
      list-style-type: none
    }

    ol.lst-kix_list_7-4 {
      list-style-type: none
    }

    ol.lst-kix_list_5-3.start {
      counter-reset: lst-ctn-kix_list_5-3 0
    }

    .lst-kix_list_2-3>li {
      counter-increment: lst-ctn-kix_list_2-3
    }

    .lst-kix_list_4-3>li {
      counter-increment: lst-ctn-kix_list_4-3
    }

    ol.lst-kix_list_4-5.start {
      counter-reset: lst-ctn-kix_list_4-5 0
    }

    .lst-kix_list_1-2>li {
      counter-increment: lst-ctn-kix_list_1-2
    }

    ol.lst-kix_list_3-7.start {
      counter-reset: lst-ctn-kix_list_3-7 0
    }

    .lst-kix_list_3-2>li {
      counter-increment: lst-ctn-kix_list_3-2
    }

    .lst-kix_list_7-2>li {
      counter-increment: lst-ctn-kix_list_7-2
    }

    .lst-kix_list_5-0>li:before {
      content: ""counter(lst-ctn-kix_list_5-0, decimal) ". "
    }

    ol.lst-kix_list_6-0 {
      list-style-type: none
    }

    ol.lst-kix_list_6-1 {
      list-style-type: none
    }

    .lst-kix_list_5-4>li {
      counter-increment: lst-ctn-kix_list_5-4
    }

    .lst-kix_list_1-4>li {
      counter-increment: lst-ctn-kix_list_1-4
    }

    ol.lst-kix_list_1-6.start {
      counter-reset: lst-ctn-kix_list_1-6 0
    }

    .lst-kix_list_5-3>li:before {
      content: ""counter(lst-ctn-kix_list_5-3, decimal) ". "
    }

    .lst-kix_list_5-2>li:before {
      content: "\0025aa  "
    }

    .lst-kix_list_5-1>li:before {
      content: ""counter(lst-ctn-kix_list_5-1, upper-latin) ". "
    }

    .lst-kix_list_5-7>li:before {
      content: ""counter(lst-ctn-kix_list_5-7, decimal) ". "
    }

    .lst-kix_list_5-6>li:before {
      content: ""counter(lst-ctn-kix_list_5-6, decimal) ". "
    }

    .lst-kix_list_5-8>li:before {
      content: ""counter(lst-ctn-kix_list_5-8, decimal) ". "
    }

    ol.lst-kix_list_6-6 {
      list-style-type: none
    }

    ol.lst-kix_list_6-7 {
      list-style-type: none
    }

    .lst-kix_list_5-4>li:before {
      content: ""counter(lst-ctn-kix_list_5-4, decimal) ". "
    }

    ol.lst-kix_list_6-8 {
      list-style-type: none
    }

    .lst-kix_list_5-5>li:before {
      content: ""counter(lst-ctn-kix_list_5-5, decimal) ". "
    }

    ol.lst-kix_list_6-2 {
      list-style-type: none
    }

    ol.lst-kix_list_6-3 {
      list-style-type: none
    }

    ol.lst-kix_list_6-4 {
      list-style-type: none
    }

    ol.lst-kix_list_6-5 {
      list-style-type: none
    }

    ol.lst-kix_list_1-0.start {
      counter-reset: lst-ctn-kix_list_1-0 0
    }

    .lst-kix_list_6-1>li:before {
      content: ""counter(lst-ctn-kix_list_6-1, upper-latin) ". "
    }

    .lst-kix_list_6-3>li:before {
      content: ""counter(lst-ctn-kix_list_6-3, decimal) ". "
    }

    .lst-kix_list_6-5>li {
      counter-increment: lst-ctn-kix_list_6-5
    }

    .lst-kix_list_6-8>li {
      counter-increment: lst-ctn-kix_list_6-8
    }

    .lst-kix_list_6-0>li:before {
      content: ""counter(lst-ctn-kix_list_6-0, decimal) ". "
    }

    .lst-kix_list_6-4>li:before {
      content: ""counter(lst-ctn-kix_list_6-4, decimal) ". "
    }

    .lst-kix_list_3-0>li {
      counter-increment: lst-ctn-kix_list_3-0
    }

    ol.lst-kix_list_4-0.start {
      counter-reset: lst-ctn-kix_list_4-0 0
    }

    .lst-kix_list_3-6>li {
      counter-increment: lst-ctn-kix_list_3-6
    }

    .lst-kix_list_6-2>li:before {
      content: ""counter(lst-ctn-kix_list_6-2, lower-roman) ". "
    }

    .lst-kix_list_2-5>li {
      counter-increment: lst-ctn-kix_list_2-5
    }

    .lst-kix_list_2-8>li {
      counter-increment: lst-ctn-kix_list_2-8
    }

    ol.lst-kix_list_3-2.start {
      counter-reset: lst-ctn-kix_list_3-2 0
    }

    .lst-kix_list_6-8>li:before {
      content: ""counter(lst-ctn-kix_list_6-8, decimal) ". "
    }

    .lst-kix_list_6-5>li:before {
      content: ""counter(lst-ctn-kix_list_6-5, decimal) ". "
    }

    .lst-kix_list_6-7>li:before {
      content: ""counter(lst-ctn-kix_list_6-7, decimal) ". "
    }

    ol.lst-kix_list_2-4.start {
      counter-reset: lst-ctn-kix_list_2-4 0
    }

    .lst-kix_list_6-6>li:before {
      content: ""counter(lst-ctn-kix_list_6-6, decimal) ". "
    }

    ol.lst-kix_list_1-3 {
      list-style-type: none
    }

    ol.lst-kix_list_1-4 {
      list-style-type: none
    }

    .lst-kix_list_2-7>li:before {
      content: ""counter(lst-ctn-kix_list_2-7, decimal) ". "
    }

    .lst-kix_list_2-7>li {
      counter-increment: lst-ctn-kix_list_2-7
    }

    ol.lst-kix_list_1-5 {
      list-style-type: none
    }

    .lst-kix_list_7-4>li:before {
      content: ""counter(lst-ctn-kix_list_7-4, decimal) ". "
    }

    .lst-kix_list_7-6>li:before {
      content: ""counter(lst-ctn-kix_list_7-6, decimal) ". "
    }

    ol.lst-kix_list_1-6 {
      list-style-type: none
    }

    ol.lst-kix_list_1-0 {
      list-style-type: none
    }

    .lst-kix_list_2-5>li:before {
      content: ""counter(lst-ctn-kix_list_2-5, decimal) ". "
    }

    ol.lst-kix_list_6-2.start {
      counter-reset: lst-ctn-kix_list_6-2 0
    }

    ol.lst-kix_list_1-1 {
      list-style-type: none
    }

    ol.lst-kix_list_1-2 {
      list-style-type: none
    }

    .lst-kix_list_7-2>li:before {
      content: ""counter(lst-ctn-kix_list_7-2, lower-roman) ". "
    }

    .lst-kix_list_7-6>li {
      counter-increment: lst-ctn-kix_list_7-6
    }

    ol.lst-kix_list_4-6.start {
      counter-reset: lst-ctn-kix_list_4-6 0
    }

    ol.lst-kix_list_3-0.start {
      counter-reset: lst-ctn-kix_list_3-0 0
    }

    .lst-kix_list_5-7>li {
      counter-increment: lst-ctn-kix_list_5-7
    }

    .lst-kix_list_7-7>li {
      counter-increment: lst-ctn-kix_list_7-7
    }

    .lst-kix_list_7-8>li:before {
      content: ""counter(lst-ctn-kix_list_7-8, decimal) ". "
    }

    ol.lst-kix_list_4-3.start {
      counter-reset: lst-ctn-kix_list_4-3 0
    }

    ol.lst-kix_list_1-7 {
      list-style-type: none
    }

    .lst-kix_list_4-7>li {
      counter-increment: lst-ctn-kix_list_4-7
    }

    ol.lst-kix_list_1-8 {
      list-style-type: none
    }

    .lst-kix_list_7-8>li {
      counter-increment: lst-ctn-kix_list_7-8
    }

    ol.lst-kix_list_2-5.start {
      counter-reset: lst-ctn-kix_list_2-5 0
    }

    .lst-kix_list_2-6>li {
      counter-increment: lst-ctn-kix_list_2-6
    }

    .lst-kix_list_4-1>li:before {
      content: ""counter(lst-ctn-kix_list_4-1, upper-latin) ". "
    }

    ol.lst-kix_list_7-3.start {
      counter-reset: lst-ctn-kix_list_7-3 0
    }

    .lst-kix_list_4-3>li:before {
      content: ""counter(lst-ctn-kix_list_4-3, decimal) ". "
    }

    .lst-kix_list_4-5>li:before {
      content: ""counter(lst-ctn-kix_list_4-5, decimal) ". "
    }

    ol.lst-kix_list_5-7.start {
      counter-reset: lst-ctn-kix_list_5-7 0
    }

    .lst-kix_list_1-8>li {
      counter-increment: lst-ctn-kix_list_1-8
    }

    ol.lst-kix_list_1-4.start {
      counter-reset: lst-ctn-kix_list_1-4 0
    }

    .lst-kix_list_5-5>li {
      counter-increment: lst-ctn-kix_list_5-5
    }

    .lst-kix_list_3-5>li {
      counter-increment: lst-ctn-kix_list_3-5
    }

    ol.lst-kix_list_1-1.start {
      counter-reset: lst-ctn-kix_list_1-1 0
    }

    .lst-kix_list_3-4>li {
      counter-increment: lst-ctn-kix_list_3-4
    }

    ol.lst-kix_list_4-4.start {
      counter-reset: lst-ctn-kix_list_4-4 0
    }

    .lst-kix_list_6-4>li {
      counter-increment: lst-ctn-kix_list_6-4
    }

    .lst-kix_list_6-3>li {
      counter-increment: lst-ctn-kix_list_6-3
    }

    ol.lst-kix_list_1-3.start {
      counter-reset: lst-ctn-kix_list_1-3 0
    }

    ol.lst-kix_list_2-8.start {
      counter-reset: lst-ctn-kix_list_2-8 0
    }

    ol.lst-kix_list_1-2.start {
      counter-reset: lst-ctn-kix_list_1-2 0
    }

    ol.lst-kix_list_7-6.start {
      counter-reset: lst-ctn-kix_list_7-6 0
    }

    ol.lst-kix_list_6-1.start {
      counter-reset: lst-ctn-kix_list_6-1 0
    }

    .lst-kix_list_1-1>li:before {
      content: ""counter(lst-ctn-kix_list_1-1, upper-latin) ". "
    }

    .lst-kix_list_1-3>li:before {
      content: ""counter(lst-ctn-kix_list_1-3, decimal) ". "
    }

    .lst-kix_list_4-8>li {
      counter-increment: lst-ctn-kix_list_4-8
    }

    .lst-kix_list_1-7>li:before {
      content: ""counter(lst-ctn-kix_list_1-7, decimal) ". "
    }

    ol.lst-kix_list_5-8.start {
      counter-reset: lst-ctn-kix_list_5-8 0
    }

    ol.lst-kix_list_2-7.start {
      counter-reset: lst-ctn-kix_list_2-7 0
    }

    .lst-kix_list_1-3>li {
      counter-increment: lst-ctn-kix_list_1-3
    }

    .lst-kix_list_1-5>li:before {
      content: ""counter(lst-ctn-kix_list_1-5, decimal) ". "
    }

    .lst-kix_list_5-6>li {
      counter-increment: lst-ctn-kix_list_5-6
    }

    ol.lst-kix_list_7-5.start {
      counter-reset: lst-ctn-kix_list_7-5 0
    }

    .lst-kix_list_2-1>li:before {
      content: ""counter(lst-ctn-kix_list_2-1, upper-latin) ". "
    }

    ol.lst-kix_list_6-0.start {
      counter-reset: lst-ctn-kix_list_6-0 0
    }

    .lst-kix_list_2-3>li:before {
      content: ""counter(lst-ctn-kix_list_2-3, decimal) ". "
    }

    .lst-kix_list_4-2>li {
      counter-increment: lst-ctn-kix_list_4-2
    }

    ol.lst-kix_list_3-1 {
      list-style-type: none
    }

    ol.lst-kix_list_3-2 {
      list-style-type: none
    }

    .lst-kix_list_3-1>li {
      counter-increment: lst-ctn-kix_list_3-1
    }

    ol.lst-kix_list_3-3 {
      list-style-type: none
    }

    ol.lst-kix_list_3-4.start {
      counter-reset: lst-ctn-kix_list_3-4 0
    }

    .lst-kix_list_5-1>li {
      counter-increment: lst-ctn-kix_list_5-1
    }

    ol.lst-kix_list_3-4 {
      list-style-type: none
    }

    ol.lst-kix_list_3-0 {
      list-style-type: none
    }

    .lst-kix_list_1-1>li {
      counter-increment: lst-ctn-kix_list_1-1
    }

    .lst-kix_list_7-1>li {
      counter-increment: lst-ctn-kix_list_7-1
    }

    ol.lst-kix_list_2-6.start {
      counter-reset: lst-ctn-kix_list_2-6 0
    }

    .lst-kix_list_3-0>li:before {
      content: ""counter(lst-ctn-kix_list_3-0, decimal) ". "
    }

    ol.lst-kix_list_7-7.start {
      counter-reset: lst-ctn-kix_list_7-7 0
    }

    .lst-kix_list_3-1>li:before {
      content: ""counter(lst-ctn-kix_list_3-1, upper-latin) ". "
    }

    .lst-kix_list_3-2>li:before {
      content: ""counter(lst-ctn-kix_list_3-2, lower-roman) ". "
    }

    ol.lst-kix_list_1-8.start {
      counter-reset: lst-ctn-kix_list_1-8 0
    }

    .lst-kix_list_4-0>li {
      counter-increment: lst-ctn-kix_list_4-0
    }

    .lst-kix_list_6-0>li {
      counter-increment: lst-ctn-kix_list_6-0
    }

    .lst-kix_list_3-5>li:before {
      content: ""counter(lst-ctn-kix_list_3-5, decimal) ". "
    }

    .lst-kix_list_3-4>li:before {
      content: ""counter(lst-ctn-kix_list_3-4, decimal) ". "
    }

    .lst-kix_list_3-3>li:before {
      content: ""counter(lst-ctn-kix_list_3-3, decimal) ". "
    }

    ol.lst-kix_list_3-5 {
      list-style-type: none
    }

    ol.lst-kix_list_3-6 {
      list-style-type: none
    }

    ol.lst-kix_list_3-7 {
      list-style-type: none
    }

    ul.lst-kix_list_5-2 {
      list-style-type: none
    }

    ol.lst-kix_list_3-8 {
      list-style-type: none
    }

    .lst-kix_list_3-8>li:before {
      content: ""counter(lst-ctn-kix_list_3-8, decimal) ". "
    }

    .lst-kix_list_2-0>li {
      counter-increment: lst-ctn-kix_list_2-0
    }

    .lst-kix_list_3-6>li:before {
      content: ""counter(lst-ctn-kix_list_3-6, decimal) ". "
    }

    .lst-kix_list_3-7>li:before {
      content: ""counter(lst-ctn-kix_list_3-7, decimal) ". "
    }

    ol.lst-kix_list_5-0.start {
      counter-reset: lst-ctn-kix_list_5-0 0
    }

    ol.lst-kix_list_4-2.start {
      counter-reset: lst-ctn-kix_list_4-2 0
    }

    ol.lst-kix_list_2-2 {
      list-style-type: none
    }

    ol.lst-kix_list_2-3 {
      list-style-type: none
    }

    ol.lst-kix_list_2-4 {
      list-style-type: none
    }

    ol.lst-kix_list_7-2.start {
      counter-reset: lst-ctn-kix_list_7-2 0
    }

    ol.lst-kix_list_2-5 {
      list-style-type: none
    }

    .lst-kix_list_4-4>li {
      counter-increment: lst-ctn-kix_list_4-4
    }

    ol.lst-kix_list_2-0 {
      list-style-type: none
    }

    ol.lst-kix_list_2-1 {
      list-style-type: none
    }

    .lst-kix_list_4-8>li:before {
      content: ""counter(lst-ctn-kix_list_4-8, decimal) ". "
    }

    ol.lst-kix_list_6-4.start {
      counter-reset: lst-ctn-kix_list_6-4 0
    }

    .lst-kix_list_4-7>li:before {
      content: ""counter(lst-ctn-kix_list_4-7, decimal) ". "
    }

    ol.lst-kix_list_5-6.start {
      counter-reset: lst-ctn-kix_list_5-6 0
    }

    ol.lst-kix_list_4-1.start {
      counter-reset: lst-ctn-kix_list_4-1 0
    }

    .lst-kix_list_7-3>li {
      counter-increment: lst-ctn-kix_list_7-3
    }

    ol.lst-kix_list_4-8.start {
      counter-reset: lst-ctn-kix_list_4-8 0
    }

    ol.lst-kix_list_3-3.start {
      counter-reset: lst-ctn-kix_list_3-3 0
    }

    ol.lst-kix_list_2-6 {
      list-style-type: none
    }

    ol.lst-kix_list_2-7 {
      list-style-type: none
    }

    ol.lst-kix_list_2-8 {
      list-style-type: none
    }

    ol.lst-kix_list_7-8.start {
      counter-reset: lst-ctn-kix_list_7-8 0
    }

    ol.lst-kix_list_7-1.start {
      counter-reset: lst-ctn-kix_list_7-1 0
    }

    .lst-kix_list_3-3>li {
      counter-increment: lst-ctn-kix_list_3-3
    }

    ol.lst-kix_list_6-3.start {
      counter-reset: lst-ctn-kix_list_6-3 0
    }

    ol.lst-kix_list_5-5.start {
      counter-reset: lst-ctn-kix_list_5-5 0
    }

    .lst-kix_list_7-0>li:before {
      content: ""counter(lst-ctn-kix_list_7-0, decimal) ". "
    }

    .lst-kix_list_2-2>li {
      counter-increment: lst-ctn-kix_list_2-2
    }

    ol.lst-kix_list_4-7.start {
      counter-reset: lst-ctn-kix_list_4-7 0
    }

    .lst-kix_list_6-2>li {
      counter-increment: lst-ctn-kix_list_6-2
    }

    ol.lst-kix_list_5-0 {
      list-style-type: none
    }

    .lst-kix_list_2-6>li:before {
      content: ""counter(lst-ctn-kix_list_2-6, decimal) ". "
    }

    .lst-kix_list_3-7>li {
      counter-increment: lst-ctn-kix_list_3-7
    }

    ol.lst-kix_list_5-1 {
      list-style-type: none
    }

    .lst-kix_list_2-4>li:before {
      content: ""counter(lst-ctn-kix_list_2-4, decimal) ". "
    }

    .lst-kix_list_2-8>li:before {
      content: ""counter(lst-ctn-kix_list_2-8, decimal) ". "
    }

    .lst-kix_list_7-1>li:before {
      content: ""counter(lst-ctn-kix_list_7-1, upper-latin) ". "
    }

    .lst-kix_list_7-5>li:before {
      content: ""counter(lst-ctn-kix_list_7-5, decimal) ". "
    }

    .lst-kix_list_6-6>li {
      counter-increment: lst-ctn-kix_list_6-6
    }

    ol.lst-kix_list_5-4.start {
      counter-reset: lst-ctn-kix_list_5-4 0
    }

    .lst-kix_list_7-3>li:before {
      content: ""counter(lst-ctn-kix_list_7-3, decimal) ". "
    }

    ol.lst-kix_list_5-1.start {
      counter-reset: lst-ctn-kix_list_5-1 0
    }

    ol.lst-kix_list_5-7 {
      list-style-type: none
    }

    .lst-kix_list_6-7>li {
      counter-increment: lst-ctn-kix_list_6-7
    }

    ol.lst-kix_list_5-8 {
      list-style-type: none
    }

    ol.lst-kix_list_5-3 {
      list-style-type: none
    }

    ol.lst-kix_list_5-4 {
      list-style-type: none
    }

    .lst-kix_list_1-7>li {
      counter-increment: lst-ctn-kix_list_1-7
    }

    ol.lst-kix_list_3-8.start {
      counter-reset: lst-ctn-kix_list_3-8 0
    }

    ol.lst-kix_list_5-5 {
      list-style-type: none
    }

    ol.lst-kix_list_5-6 {
      list-style-type: none
    }

    .lst-kix_list_7-7>li:before {
      content: ""counter(lst-ctn-kix_list_7-7, decimal) ". "
    }

    .lst-kix_list_7-5>li {
      counter-increment: lst-ctn-kix_list_7-5
    }

    .lst-kix_list_5-8>li {
      counter-increment: lst-ctn-kix_list_5-8
    }

    .lst-kix_list_4-0>li:before {
      content: ""counter(lst-ctn-kix_list_4-0, decimal) ". "
    }

    .lst-kix_list_3-8>li {
      counter-increment: lst-ctn-kix_list_3-8
    }

    ol.lst-kix_list_6-8.start {
      counter-reset: lst-ctn-kix_list_6-8 0
    }

    .lst-kix_list_4-6>li {
      counter-increment: lst-ctn-kix_list_4-6
    }

    ol.lst-kix_list_1-7.start {
      counter-reset: lst-ctn-kix_list_1-7 0
    }

    .lst-kix_list_4-4>li:before {
      content: ""counter(lst-ctn-kix_list_4-4, decimal) ". "
    }

    ol.lst-kix_list_2-2.start {
      counter-reset: lst-ctn-kix_list_2-2 0
    }

    .lst-kix_list_1-5>li {
      counter-increment: lst-ctn-kix_list_1-5
    }

    ol.lst-kix_list_6-5.start {
      counter-reset: lst-ctn-kix_list_6-5 0
    }

    .lst-kix_list_4-2>li:before {
      content: ""counter(lst-ctn-kix_list_4-2, lower-roman) ". "
    }

    .lst-kix_list_4-6>li:before {
      content: ""counter(lst-ctn-kix_list_4-6, decimal) ". "
    }

    ol.lst-kix_list_7-0.start {
      counter-reset: lst-ctn-kix_list_7-0 0
    }

    ol.lst-kix_list_4-0 {
      list-style-type: none
    }

    ol.lst-kix_list_4-1 {
      list-style-type: none
    }

    ol.lst-kix_list_4-2 {
      list-style-type: none
    }

    ol.lst-kix_list_4-3 {
      list-style-type: none
    }

    .lst-kix_list_2-4>li {
      counter-increment: lst-ctn-kix_list_2-4
    }

    ol.lst-kix_list_6-7.start {
      counter-reset: lst-ctn-kix_list_6-7 0
    }

    ol.lst-kix_list_3-6.start {
      counter-reset: lst-ctn-kix_list_3-6 0
    }

    .lst-kix_list_5-3>li {
      counter-increment: lst-ctn-kix_list_5-3
    }

    ol.lst-kix_list_4-8 {
      list-style-type: none
    }

    .lst-kix_list_7-4>li {
      counter-increment: lst-ctn-kix_list_7-4
    }

    .lst-kix_list_1-0>li:before {
      content: ""counter(lst-ctn-kix_list_1-0, decimal) ". "
    }

    ol.lst-kix_list_4-4 {
      list-style-type: none
    }

    ol.lst-kix_list_4-5 {
      list-style-type: none
    }

    .lst-kix_list_1-2>li:before {
      content: ""counter(lst-ctn-kix_list_1-2, lower-roman) ". "
    }

    ol.lst-kix_list_2-0.start {
      counter-reset: lst-ctn-kix_list_2-0 0
    }

    ol.lst-kix_list_4-6 {
      list-style-type: none
    }

    ol.lst-kix_list_4-7 {
      list-style-type: none
    }

    .lst-kix_list_1-4>li:before {
      content: ""counter(lst-ctn-kix_list_1-4, decimal) ". "
    }

    ol.lst-kix_list_3-5.start {
      counter-reset: lst-ctn-kix_list_3-5 0
    }

    .lst-kix_list_1-0>li {
      counter-increment: lst-ctn-kix_list_1-0
    }

    .lst-kix_list_1-6>li {
      counter-increment: lst-ctn-kix_list_1-6
    }

    .lst-kix_list_1-6>li:before {
      content: ""counter(lst-ctn-kix_list_1-6, decimal) ". "
    }

    .lst-kix_list_2-0>li:before {
      content: ""counter(lst-ctn-kix_list_2-0, decimal) ". "
    }

    ol.lst-kix_list_2-1.start {
      counter-reset: lst-ctn-kix_list_2-1 0
    }

    .lst-kix_list_4-5>li {
      counter-increment: lst-ctn-kix_list_4-5
    }

    .lst-kix_list_1-8>li:before {
      content: ""counter(lst-ctn-kix_list_1-8, decimal) ". "
    }

    .lst-kix_list_2-2>li:before {
      content: ""counter(lst-ctn-kix_list_2-2, lower-roman) ". "
    }

    ol {
      margin: 0;
      padding: 0
    }

    table td,
    table th {
      padding: 0
    }

    .c9 {
      margin-left: 36pt;
      padding-top: 0pt;
      padding-left: 0pt;
      padding-bottom: 14pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .c7 {
      margin-left: 108pt;
      padding-top: 0pt;
      padding-left: 0pt;
      padding-bottom: 0pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .c18 {
      margin-left: 36pt;
      padding-top: 14pt;
      padding-left: 0pt;
      padding-bottom: 0pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .c6 {
      margin-left: 72pt;
      padding-top: 14pt;
      padding-left: 0pt;
      padding-bottom: 0pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .c22 {
      margin-left: 36pt;
      padding-top: 0pt;
      padding-left: 0pt;
      padding-bottom: 0pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .c2 {
      margin-left: 72pt;
      padding-top: 0pt;
      padding-left: 0pt;
      padding-bottom: 0pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .c0 {
      margin-left: 72pt;
      padding-top: 14pt;
      padding-left: 0pt;
      padding-bottom: 14pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .c14 {
      margin-left: 108pt;
      padding-top: 14pt;
      padding-left: 0pt;
      padding-bottom: 14pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .c11 {
      padding-top: 14pt;
      padding-bottom: 14pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left;
      height: 12pt
    }

    .c4 {
      color: #000000;
      font-weight: 400;
      text-decoration: none;
      vertical-align: baseline;
      font-size: 12pt;
      font-family: "Arial";
      font-style: normal
    }

    .c20 {
      padding-top: 0pt;
      padding-bottom: 0pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left;
      height: 12pt
    }

    .c10 {
      color: #000000;
      font-weight: 400;
      text-decoration: none;
      vertical-align: baseline;
      font-size: 12pt;
      font-family: "Calibri";
      font-style: normal
    }

    .c12 {
      padding-top: 0pt;
      padding-bottom: 14pt;
      line-height: 1.0;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .c19 {
      text-decoration: none;
      vertical-align: baseline;
      font-size: 12pt;
      font-style: normal
    }

    .c3 {
      background-color: #ffff00;
      font-family: "Arial";
      font-weight: 400
    }

    .c23 {
      -webkit-text-decoration-skip: none;
      text-decoration: underline;
      text-decoration-skip-ink: none
    }

    .c15 {
      margin-left: 72pt;
      text-indent: -72pt
    }

    .c8 {
      font-weight: 700;
      font-family: "Arial"
    }

    .c24 {
      max-width: 468pt;
      padding: 72pt 72pt 72pt 72pt
    }

    .c13 {
      margin-left: 72pt;
      padding-left: 0pt
    }

    .c5 {
      font-weight: 400;
      font-family: "Arial"
    }

    .c1 {
      padding: 0;
      margin: 0
    }

    .c16 {
      color: inherit;
      text-decoration: inherit
    }

    .c17 {
      color: #000000
    }

    .c21 {
      background-color: #ffffff
    }

    .title {
      padding-top: 24pt;
      color: #000000;
      font-weight: 700;
      font-size: 36pt;
      padding-bottom: 6pt;
      font-family: "Calibri";
      line-height: 1.0;
      page-break-after: avoid;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    .subtitle {
      padding-top: 18pt;
      color: #666666;
      font-size: 24pt;
      padding-bottom: 4pt;
      font-family: "Georgia";
      line-height: 1.0;
      page-break-after: avoid;
      font-style: italic;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    li {
      color: #000000;
      font-size: 12pt;
      font-family: "Calibri"
    }

    p {
      margin: 0;
      color: #000000;
      font-size: 12pt;
      font-family: "Calibri"
    }

    h1 {
      padding-top: 24pt;
      color: #000000;
      font-weight: 700;
      font-size: 24pt;
      padding-bottom: 6pt;
      font-family: "Calibri";
      line-height: 1.0;
      page-break-after: avoid;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    h2 {
      padding-top: 18pt;
      color: #000000;
      font-weight: 700;
      font-size: 18pt;
      padding-bottom: 4pt;
      font-family: "Calibri";
      line-height: 1.0;
      page-break-after: avoid;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    h3 {
      padding-top: 14pt;
      color: #000000;
      font-weight: 700;
      font-size: 14pt;
      padding-bottom: 4pt;
      font-family: "Calibri";
      line-height: 1.0;
      page-break-after: avoid;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    h4 {
      padding-top: 12pt;
      color: #000000;
      font-weight: 700;
      font-size: 12pt;
      padding-bottom: 2pt;
      font-family: "Calibri";
      line-height: 1.0;
      page-break-after: avoid;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    h5 {
      padding-top: 11pt;
      color: #000000;
      font-weight: 700;
      font-size: 11pt;
      padding-bottom: 2pt;
      font-family: "Calibri";
      line-height: 1.0;
      page-break-after: avoid;
      orphans: 2;
      widows: 2;
      text-align: left
    }

    h6 {
      padding-top: 10pt;
      color: #000000;
      font-weight: 700;
      font-size: 10pt;
      padding-bottom: 2pt;
      font-family: "Calibri";
      line-height: 1.0;
      page-break-after: avoid;
      orphans: 2;
      widows: 2;
      text-align: left
    }
  </style>
  <div class="modal__body">
    <i class="fal fa-times modal__close" (click)="onCloseClick()"></i>
    <h1 class="h2">Terms and conditions</h1>
    <p class="c12"><span class="c5">Welcome to the Action Builder Organizing Toolset (the &ldquo;</span><span
        class="c8">Services</span><span class="c5">&rdquo;) provided by Action Squared (&ldquo;</span><span
        class="c8">we</span><span class="c5">&rdquo;, &ldquo;</span><span class="c8">us</span><span class="c5">&rdquo;,
        &ldquo;</span><span class="c8">our</span><span class="c5">&rdquo;, &quot;</span><span class="c8">Action
        Squared&rdquo;</span><span class="c5">). If you have any questions, comments or concerns regarding these Master
        Terms or our Services, please contact us at&nbsp; </span><span class="c5 c17 c23"><a class="c16"
          href="mailto:support@actionnetwork.com">support&#64;actionnetwork.com</a></span><span class="c4">.</span></p>
    <ol class="c1 lst-kix_list_5-0 start" start="1">
      <li class="c18"><span class="c8">Statement of Purpose</span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-1 start" start="1">
      <li class="c12 c13" id="h.gjdgxs"><span class="c5 c17">Action Squared builds infrastructure for the progressive
          movement using a sustainable, cooperative model grounded in respect, shared ownership and transparency,
          motivated by building progressive power rather than profit.</span></li>
      <li class="c0" id="h.30j0zll"><span class="c5">Our purpose excludes use of the Services by any corporation,
          association, organization, or other person </span><span class="c5 c17">(collectively, an &ldquo;entity&rdquo;)
          (a) that opposes the unionization of workers in any context, including but not limited to its own workforce
          (whether or not such workforce is covered by the protections of the National Labor Relations Act &nbsp;(the
          &ldquo;NLRA&rdquo;) and whether or not they are deemed &ldquo;independent contractors,&rdquo;
          &ldquo;employees,&rdquo; or any other categorization); for the avoidance of doubt, this provision is not
          intended to preclude licensing to an entity that is an employer of unionized workers and that exercises its
          established rights under the NLRA or other applicable labor laws in the resolution of a contract dispute; (b)
          that advocates in federal, state, or local bodies for anti-worker policies such as &ldquo;right-to-work&rdquo;
          legislation, referenda, or other measures; (c) for any use that opposes or diminishes in a material respect
          the rights or ability of working people to form unions and bargain collectively with their employers; (d) for
          any use that seeks to interfere with a union&rsquo;s established collective bargaining relationship with an
          employee that has either been recognized by the employer or has been certified by the National Labor Relations
          Board or other federal or state agency as the collective bargaining representative for the employee; and (e)
          for any use supporting or opposing the candidacy of a person or slate of persons for any elected office in a
          union, labor federation, or other labor organization.</span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="2">
      <li class="c18"><span class="c8">Agreement; Structure of Our Terms and Conditions</span><span
          class="c4"><br></span>
      </li>
    </ol>
    <ol class="c1 lst-kix_list_5-1 start" start="1">
      <li class="c2"><span class="c5">These Master Terms of Service, and any applicable Additional Terms referenced
          below (together, the &ldquo;</span><span class="c8">Master Terms</span><span class="c5">&rdquo;), contain the
          terms and conditions that apply to use of our Services. &nbsp;By clicking the &ldquo;I Accept&rdquo; box, you
          indicate that these Master Terms constitute a binding agreement between us and you (referred to herein as
          &ldquo;</span><span class="c8">you</span><span class="c5">&rdquo; or &ldquo;</span><span
          class="c8">your</span><span class="c5">&rdquo;), an authorized user pursuant to an agreement between your
          organization and Action Squared and that you have read and understood the following terms, including those in
          our Privacy Policy. </span></li>
    </ol>
    <p class="c15 c20"><span class="c4"></span></p>
    <ol class="c1 lst-kix_list_5-1" start="2">
      <li class="c2"><span class="c4">Additional Documents. The following additional policy documents, as described
          herein, are also incorporated by reference in these Master Terms:<br></span></li>
    </ol>
    <ul class="c1 lst-kix_list_5-2 start">
      <li class="c7"><span class="c5"><a href="https://actionnetwork.org/privacy" target="_blank">Privacy
            Policy</a></span></li>
      <li class="c7"><span class="c5"><a
            href="https://actionbuilder.zendesk.com/hc/en-us/articles/360037117912-Acceptable-Use-Policy"
            target="_blank">Acceptable Use Policy: Action Builder</a> </span>
      </li>
    </ul>
    <ol class="c1 lst-kix_list_5-0" start="3">
      <li class="c18"><span class="c8">Changes to Services and Master Terms<br></span><span class="c4"><br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-1 start" start="1">
      <li class="c2"><span class="c4">We may change these Master Terms at any time in our sole discretion without notice
          to you by posting revised Master Terms on the Services, and your continued use of the Services following the
          posting of those changes will confirm your acceptance of them. Therefore, you should review the Master Terms
          from time to time to understand the terms and conditions that apply to your access to and use of the Services.
          If you do not agree to the amended terms, you must stop using the Services.</span></li>
      <li class="c2"><span class="c4">Except for changes by us as described here, no other amendment or modification of
          these Master Terms will be effective unless in writing and signed by both you and us.<br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="4">
      <li class="c22"><span class="c8">Privacy<br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-1 start" start="1">
      <li class="c2"><span class="c5">Your privacy is important to us. Please refer to our&nbsp;</span><span
          class="c5"><a href="https://actionnetwork.org/privacy" target="_blank">Privacy
            Policy</a></span><span class="c4">&nbsp;for
          information on how we collect, use and disclose personally identifiable information from our users.<br></span>
      </li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="5">
      <li class="c22"><span class="c8">Basics of Using the Services<br></span><span class="c4"><br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-1 start" start="1">
      <li class="c2"><span class="c5">In order to use our Services, you will be required to select a password and
          username (&ldquo;</span><span class="c8">Login Credentials</span><span class="c4">&rdquo;). </span></li>
      <li class="c2"><span class="c4">You must follow all applicable laws in your use of the Services. If your use of
          the Services is prohibited by applicable laws, then you aren&rsquo;t authorized to use the Services. We
          can&rsquo;t and won&rsquo;t be responsible for your using the Services in a way that breaks the law. We may
          suspend or terminate your use of the Services if you do not follow our Master Terms. </span></li>
      <li class="c2"><span class="c4">You understand that we own the Services. You agree not to modify, publish,
          transmit, participate in the transfer or sale of, reproduce (except as expressly provided in the Master Terms)
          creative derivative works based on, or otherwise exploit any of the Services. </span></li>
      <li class="c2"><span class="c4">These Master Terms grant you a non-exclusive, limited, non-transferable, freely
          revocable license to use the Services, subject to your compliance with the Master Terms. We may terminate this
          license at any time for violation of our terms and policies.<br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="6">
      <li class="c22"><span class="c8">User Accounts.</span><span class="c4"><br><br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-1 start" start="1">
      <li class="c2"><span class="c4">You agree to (i) provide truthful and accurate registration information as
          requested by us; (ii) promptly inform us of any changes to your registration information, including, but not
          limited to, your address and email address; (iii) take all reasonable precautions to safeguard access to your
          password and to prevent unauthorized access to or use of the Services; (iv) promptly report to us any
          unauthorized use of your login information or the Services of which you become aware; and, (v) ensure that you
          log out from the Services at the end of each session.</span></li>
      <li class="c12 c13"><span class="c4">You are responsible for keeping your Login Credentials confidential and not
          sharing them with unauthorized users. If you disclose your login credentials to someone, you are responsible
          for any use, disclosure, additions, deletions and modifications of your information. </span></li>
    </ol>
    <p class="c11"><span class="c4"></span></p>
    <ol class="c1 lst-kix_list_5-0" start="7">
      <li class="c18"><span class="c8">Data Security<br></span><span class="c4"><br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-1 start" start="1">
      <li class="c2"><span class="c4">We take data security and privacy very seriously. We take reasonable precautions
          to protect the security of your information. We have physical, electronic, and managerial procedures to help
          safeguard, prevent unauthorized access, maintain data security, and correctly use your information. However,
          neither people nor security systems are foolproof, including encryption systems. In addition, people can
          commit intentional crimes, make mistakes, or fail to follow policies. Therefore, while we use reasonable
          efforts to protect your information, we cannot guarantee its security. You are responsible for the security of
          your personal information. </span></li>
      <li class="c2"><span class="c4">You understand and agree that we may disclose your information if required to do
          so by law, court order, legal process, or subpoena, including to respond to any government or regulatory
          request, or if we believe that such action is necessary to (a) conform to the law, comply with legal process
          served on us or our affiliates or partners, or investigate, prevent, or take action regarding suspected or
          actual illegal activities; (b) enforce our Master Terms (including for billing and collection purposes), take
          precautions against liability, to investigate and defend ourselves against any third-party claims or
          allegations, to assist government enforcement agencies, or to protect the security or integrity of our site;
          and (c) exercise or protect the rights, property, or personal safety of Action Squared, our users or
          others.<br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="8">
      <li class="c22"><span class="c8">Intellectual Property Rights<br></span><span class="c4"><br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-1 start" start="1">
      <li class="c2"><span class="c4">Ownership of all intellectual property and other rights in the Services and our
          website, including, but not limited to, the software, design, layout, content, links, and the like shall
          remain with us and our licensors, developers, and partners, as applicable. All content is protected by
          copyright and is owned by us or used with permission. We reserve all rights not specifically granted in these
          Master Terms.</span></li>
      <li class="c2"><span class="c4">Our name, the names of our Services, and our logos, as well as all other
          trademarks we use, are trademarks or registered trademarks of Action Squared or its affiliates. Other than as
          specifically provided herein, you may not use our trademarks in any other way, including, but not limited to,
          that our trademarks may not be copied or imitated in whole or in part by any means, including but not limited
          to, the use of framing or mirrors. None of the content for our website may be retransmitted without our
          express written consent.</span></li>
      <li class="c2"><span class="c5">The materials displayed or performed or available on or through the Services,
          including, but not limited to, text, graphics, data, articles, photos, images, illustrations, and so forth
          (all of the foregoing, the &ldquo;</span><span class="c8">Services Content</span><span class="c4">&rdquo;) are
          protected by copyright and/or other intellectual property laws. You promise to abide by all copyright notices,
          trademark laws, information, and restrictions contained in any Services Content that you access through the
          Services, and you won&rsquo;t use, copy, reproduce, modify, translate, publish, broadcast, transmit,
          distribute, perform, upload, display, license, sell or otherwise exploit for any purpose any Services Content
          not owned by you, (i) without the prior consent of the owner of that Services Content or (ii) in a way that
          violates our or any third party&rsquo;s rights.<br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="9">
      <li class="c9"><span class="c8 c17 c19">Acceptable Use</span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-1 start" start="1">
      <li class="c6"><span class="c5 c21">In addition to the general restrictions contained above, your use of our
          Services is subject to our <a
          href="https://actionbuilder.zendesk.com/hc/en-us/articles/360037117912-Acceptable-Use-Policy"
          target="_blank">Acceptable Use Policy</a> of Action Builder </span><span
          class="c5 c21"> </span></li>
      <li class="c2"><span class="c4">We have the right, but not the obligation, in our sole and absolute discretion,
          and without giving you any prior notice, to remove any content that we determine:</span></li>
    </ol>
    <ul class="c1 lst-kix_list_5-2 start">
      <li class="c7"><span class="c5">Violates these MasterTerms and/or the Acceptable Use Policy</span></li>
      <li class="c7"><span class="c5">We are required by law or court order to remove; or</span></li>
      <li class="c7"><span class="c5">We have been requested to remove by the user or other source which provided such
          content.</span></li>
    </ul>
    <ol class="c1 lst-kix_list_5-1" start="3">
      <li class="c2"><span class="c4">We also have the right, but not the obligation, to take any of the following
          actions in our sole and absolute discretion at any time and for any reason without giving you any prior
          notice:</span></li>
    </ol>
    <ul class="c1 lst-kix_list_5-2 start">
      <li class="c7"><span class="c5">Restrict, suspend, or terminate your access to all or any part of the
          Services;</span></li>
      <li class="c7"><span class="c5">Change, suspend, or discontinue all or any part of the Services;</span></li>
      <li class="c7"><span class="c5">Refuse, move, or remove any material that you submit to the Services; or</span>
      </li>
      <li class="c14"><span class="c4">You agree that we will not be liable to you or any third party for taking or not
          taking any of these actions.</span></li>
    </ul>
    <ol class="c1 lst-kix_list_5-0" start="10">
      <li class="c9"><span class="c8">Data Storage</span></li>
    </ol>
    <ol class="c1 lst-kix_list_6-1 start" start="1">
      <li class="c0"><span class="c4">You agree that we have permission to download your Data that you upload to the
          Service and store such Data on our (or our service provider&rsquo;s) servers if we reasonably deem it
          necessary in order to assist you in responding to a customer service request, responding to a distributed
          denial of service attack (DDOS), to preserve your Data, etc.</span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="11">
      <li class="c9"><span class="c8">Responsibility for Content</span></li>
    </ol>
    <ol class="c1 lst-kix_list_7-1 start" start="1">
      <li class="c2"><span class="c4">Content and information displayed on the Services is the sole responsibility of
          the person or organization providing that content, and you access all such content and information at your
          sole risk. We are not liable for any errors or omissions in that content or information, or for any damages or
          loss you might suffer in connection with it. We do not review content posted on the Services, and any issues
          with that content should be directed to its owners. You are solely responsible for interactions with other
          users of the Services.</span></li>
      <li class="c0"><span class="c4">The Services may contain links or connections to third-party websites or services
          that are not owned or controlled by us. When you access third-party websites or use third-party services, you
          accept that there are risks in doing so, and that we are not responsible for such risks. We encourage you to
          be aware when you leave the Services and to read the terms and conditions and privacy policy of each
          third-party website or service that you visit or utilize. We have no control over, and assume no
          responsibility for, the content, accuracy, privacy policies, or practices of or opinions expressed in any
          third-party websites or by any third-party that you interact with through the Services. By using the Services,
          you release and hold us harmless from any and all liability arising from your use of any third-party website
          or service.</span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="12">
      <li class="c9"><span class="c8">Disclaimer</span></li>
    </ol>
    <ol class="c1 lst-kix_list_1-1 start" start="1">
      <li class="c2"><span class="c4">YOUR USE OF THE SERVICES IS AT YOUR OWN RISK. THE SERVICES, AND ALL INFORMATION,
          CONTENT AND MATERIALS CONTAINED THEREIN, ARE PROVIDED ON AN &quot;AS IS, AS AVAILABLE&quot; BASIS. WE DO NOT
          MAKE ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, WARRANTIES OF TITLE
          AND NON-INFRINGEMENT, IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE, OR WARRANTIES
          AS TO THE ACCURACY, RELIABILITY OR COMPLETENESS OF THE INFORMATION, CONTENT OR MATERIALS ACCESSED THROUGH THE
          SITE.</span></li>
      <li class="c2"><span class="c4">WHILE WE MAKE REASONABLE ATTEMPTS TO MAKE YOUR ACCESS TO AND USE OF THE SERVICES
          SAFE, WE CANNOT AND DO NOT REPRESENT OR WARRANT THAT THE SERVICES OR INFORMATION, CONTENT AND MATERIALS
          THEREIN ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. YOU WILL BE SOLELY RESPONSIBLE FOR ANY POTENTIAL
          DAMAGES TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM YOUR DOWNLOAD OF ANY SUCH INFORMATION,
          CONTENT OR MATERIALS<br></span></li>
      <li class="c12 c13"><span class="c4">WE ARE NOT RESPONSIBLE OR LIABLE FOR THE ACTIVITIES OR CONDUCT OF ANY
          THIRD-PARTY USER OF THE SERVICES.</span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="13">
      <li class="c9"><span class="c8">Limitation of Liability</span><span class="c4"><br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_2-1 start" start="1">
      <li class="c2"><span class="c4">IN NO EVENT SHALL WE OR OUR AFFILIATES OR ANY OF OUR (OR OUR AFFILIATES&rsquo;)
          DIRECTORS, OFFICERS, EMPLOYEES, CONSULTANTS, AGENTS OR REPRESENTATIVES BE LIABLE UNDER ANY THEORY OF LIABILITY
          FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING, BUT NOT
          LIMITED TO, LOSS OF DATA OR LOSS OF PROFITS, ARISING OUT OF OR IN ANY WAY CONNECTED TO THE USE OF OR INABILITY
          TO USE THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, INCLUDING, WITHOUT
          LIMITATION, ANY DAMAGES CAUSED BY OR RESULTING FROM RELIANCE BY ANY USER ON ANY INFORMATION OR CONTENT
          OBTAINED FROM THE SITE, OR THAT RESULT FROM MISTAKES, OMISSIONS, INTERRUPTIONS, DELETION OF FILES OR EMAIL,
          ERRORS, DEFECTS, VIRUSES, DELAYS IN OPERATION OR TRANSMISSION OR ANY FAILURE OF PERFORMANCE.</span></li>
      <li class="c12 c13"><span class="c4">SOME STATES DO NOT ALLOW EXCLUSION OF IMPLIED WARRANTIES OR LIMITATION OF
          LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATIONS OR EXCLUSIONS MAY NOT APPLY TO
          YOU. IN SUCH STATES, OUR LIABILITY AND THAT OF OUR DIRECTORS, OFFICERS EMPLOYEES, CONSULTANTS, AGENTS AND
          REPRESENTATIVES SHALL BE LIMITED TO THE GREATEST EXTENT PERMITTED BY LAW.</span></li>
    </ol>
    <p class="c11 c15"><span class="c4"></span></p>
    <ol class="c1 lst-kix_list_5-0" start="14">
      <li class="c9"><span class="c8">Indemnification</span></li>
    </ol>
    <p class="c11"><span class="c4"></span></p>
    <ol class="c1 lst-kix_list_4-1 start" start="1">
      <li class="c6"><span class="c4">You agree to indemnify, defend and hold us, our Affiliates, and our (and our
          Affiliates&rsquo;) officers, directors, employees, agents, affiliates, service providers, successors and
          assigns harmless from and against any and all losses, damages, liabilities, deficiencies, claims, actions,
          judgments, settlements, interest, awards, penalties, fines, costs, or expenses of whatever kind, including
          reasonable attorneys&rsquo; fees and costs, arising from or relating to (i) your breach of these Master Terms
          or violation of applicable law; (ii) any user content you submit, post to or transmit through the Service; or
          (iii) your violation of any party&rsquo;s rights, including, but not limited to, intellectual property rights,
          right of privacy, right of publicity and confidentiality.<br><br></span></li>
    </ol>
    <ol class="c1 lst-kix_list_5-0" start="15">
      <li class="c9"><span class="c8">Other Terms</span></li>
    </ol>
    <ol class="c1 lst-kix_list_3-1 start" start="1">
      <li class="c2" id="h.1fob9te"><span class="c8">Entire Agreement.</span><span class="c4">&nbsp;These Master Terms
          constitutes the entire agreement between you and us with respect to your use of the Services. You may be
          subject to additional third-party terms and policies based on your use of the Services. No failure to
          exercise, and no delay in exercising, on the part of either party, any right or any power hereunder shall
          operate as a waiver thereof, nor shall any single or partial exercise of any right or power hereunder preclude
          further exercise of that or any other right hereunder. In the event of a conflict between these Master Terms
          and any other terms, these Master Terms shall govern. If any provision of these Master Terms is illegal or
          unenforceable under applicable law, the remainder of the provision will be amended to achieve as closely as
          possible the effect of the original term and all other provisions of these Master Terms will continue in full
          force and effect. The headings of sections and paragraphs in these Master Terms are for convenience only and
          shall not affect its interpretation.</span></li>
      <li class="c2"><span class="c8">Choice of Laws.</span><span class="c4">&nbsp;The Master Terms are governed by the
          internal substantive laws of the District of Columbia, without respect to its conflict of laws principles.
        </span></li>
      <li class="c2"><span class="c8">Force Majeure.</span><span class="c4">&nbsp;We shall not be liable to you or any
          other person, firm or entity for any failure of performance under this Agreement if such failure affecting us
          or our service providers and contractors is due to any cause or causes outside of our control, including, but
          not limited to, strikes, labor disputes, lockouts, or work stoppages, or other labor difficulties, shortages
          of labor or materials, riots, vandalism, civil disturbances, acts of terrorism, wars, third-party provider
          outages, cable cuts, power crisis shortages, infrastructure outages or failures, internet failures, computer
          equipment failures, telecommunication equipment failures, other equipment failures, electrical power failures,
          loss of or fluctuations in heat, light, or air conditioning, inclement weather, fires, floods, storms,
          explosions, and other uncontrollable acts of God or nature, or other similar occurrences; any law, order,
          regulation, direction, action or request of the United States or foreign government (including state and local
          governmental agency, department, commission, court, bureau, corporation or other instrumentality of any one or
          more of said governments) or of any civil or military authority, or national emergencies.</span></li>
      <li class="c2"><span class="c8">Notices.</span><span class="c4">&nbsp;We may provide notifications, whether such
          notifications are required by law or are for marketing or other business-related purposes, to you via email
          notice, written or hard copy notice, or through posting of such notice on the Services, as determined by us.
          We are not responsible for any automatic filtering you or your network provider may apply to email
          notifications we send to the email address you provide us. We recommend that you add support&#64;actionnetwork.com
          to your email address book to help ensure you receive email notifications from us.</span></li>
      <li class="c2"><span class="c4">No agency, partnership, joint venture, or employment is created as a result of
          these Master Terms and you do not have any authority of any kind to bind us in any respect whatsoever. You and
          we agree there are no third-party beneficiaries intended under these Master Terms.</span></li>
      <li class="c2"><span class="c8">Limitation of Time to File Claims.</span><span class="c4">&nbsp;Any action, claim
          or dispute you have against us must be filed within one year from the date the action, claim or dispute could
          first be filed. If a claim or dispute is not filed within one year, it is permanently barred.</span></li>
      <li class="c2"><span class="c8">Changes to the Master Terms.</span><span class="c4">&nbsp;We may revise and update
          these Master Terms from time to time in our sole discretion. All changes are effective immediately when we
          post them.</span></li>
      <li class="c12 c13"><span class="c8">Assignment and Transfer.</span><span class="c4">&nbsp;You may not assign,
          transfer or convey these Master Terms or any obligations thereunder without our prior written consent. Any
          assignment, transfer or conveyance by you in violation of these Master Terms shall be of no power or effect.
          You also consent to the personal information, including sensitive information, of you and that of the
          individuals stored in the Services, being assigned, transferred or conveyed in the event of a business
          transition such as, but not limited to, a merger, sale, asset or stock acquisition of us by another company,
          or other transaction or proceeding. In such a case, your information would be used as set out in our Privacy
          Policy. We may assign, transfer, or convey (whether by contract, merger, or operation of law) these Master
          Terms, or any portion thereof, in our sole discretion.</span></li>
    </ol>
    <p>
      <button class="btn" (click)="onCloseClick()">Close</button>
    </p>
  </div>
</div>